var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMasterCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 24,
    viewBox: "0 0 40 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9430_47261)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.908 21.7533C19.0014 21.8333 19.1014 21.9133 19.198 21.9933C17.2947 23.26 15.0114 24 12.5547 24C5.92802 24 0.554688 18.6267 0.554688 12C0.554688 5.37333 5.92802 0 12.5547 0C15.0114 0 17.2947 0.74 19.198 2.00667C19.1014 2.08667 19.0014 2.16333 18.908 2.24667C16.0814 4.70667 14.458 8.26333 14.458 12C14.458 15.7367 16.078 19.2933 18.908 21.7533Z",
    fill: "#646464"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3875 0C24.9308 0 22.6475 0.74 20.7441 2.00667C20.8408 2.08667 20.9408 2.16333 21.0341 2.24667C23.8608 4.70667 25.4841 8.26 25.4841 12C25.4841 15.74 23.8641 19.2933 21.0375 21.7533C20.9441 21.8333 20.8441 21.9133 20.7475 21.9933C22.6508 23.26 24.9341 24 27.3908 24C34.0175 24 39.3908 18.6267 39.3908 12C39.3908 5.37333 34.0141 0 27.3875 0Z",
    fill: "#646464"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.972 2.57031C19.8187 2.69031 19.6653 2.81698 19.5187 2.94698C16.9887 5.14698 15.3887 8.38698 15.3887 12.0003C15.3887 15.6136 16.9887 18.8536 19.5187 21.0536C19.6653 21.1836 19.8187 21.307 19.972 21.4303C20.1253 21.307 20.2787 21.1836 20.4253 21.0536C22.9553 18.8536 24.5553 15.6136 24.5553 12.0003C24.5553 8.38698 22.9553 5.14698 20.4253 2.94698C20.2787 2.81698 20.1253 2.69365 19.972 2.57031Z",
    fill: "#646464"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9430_47261"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38.8333,
    height: 24,
    fill: "white",
    transform: "translate(0.554688)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasterCard);
export default __webpack_public_path__ + "static/media/master-card.3af1e21c02509245829cc6cd373e766b.svg";
export { ForwardRef as ReactComponent };